import { useParams } from '@tanstack/react-router'
import { useRolodexEntries } from 'features/rolodex'
import { useEffect, useState } from 'react'
import { GeckoSiteObservation, RolodexEntryType } from 'types'

export const useObservations = () => {
  const [observations, setObservations] = useState<GeckoSiteObservation[]>([])
  const { siteID } = useParams({ strict: false })
  const {
    siteObservations,
    isLoading: isLoadingSiteObservations,
    forceRefresh: forecRefreshObservations,
  } = useRolodexEntries(
    siteID
      ? {
          type: [RolodexEntryType.OBSERVATION],
          tags: { [RolodexEntryType.SITE]: siteID },
          filters: [
            {
              field: 'data.alive',
              op: '=',
              value: 'true',
            },
          ],
        }
      : undefined
  )

  const { observationTickets, forceRefresh: forceRefreshTickets } =
    useRolodexEntries(
      siteID
        ? {
            type: [RolodexEntryType.OBSERVATION_TICKET],
            tags: { [RolodexEntryType.SITE]: siteID },
          }
        : undefined
    )

  const forceRefreshObservationFetchers = async () => {
    await Promise.all([forceRefreshTickets(), forecRefreshObservations()])
  }

  useEffect(() => {
    if (!isLoadingSiteObservations && siteObservations) {
      const processedObservations = [...siteObservations].map(
        (entry) => entry as unknown as GeckoSiteObservation
      )
      setObservations(processedObservations)
    }
  }, [siteObservations, isLoadingSiteObservations, siteID])

  return {
    observations,
    setObservations,
    siteObservationTickets: observationTickets,
    isLoadingSiteObservations,
    forceRefresh: forceRefreshObservationFetchers,
  }
}
